import { Link } from "react-router-dom";
import { getLatestArticles } from "@/mocks/articles";
import { getCategoryBySlug } from "@/mocks/categories";

export default function HomeLatest() {
  const latest = getLatestArticles(6);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
              最新文章
            </h2>
            <p className="text-sm text-foreground-600">
              随时掌握直播领域的最新动态
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {latest.map((article) => {
            const cat = getCategoryBySlug(article.category);
            return (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group rounded-xl bg-background-100 overflow-hidden hover:bg-background-200/30 transition-all duration-300 cursor-pointer"
              >
                <div className="w-full h-48 overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    title={`糖果直播-${article.title}`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5">
                  <span className="inline-block px-2.5 py-1 text-xs font-medium bg-accent-100 text-accent-700 rounded-full mb-3 whitespace-nowrap">
                    {cat?.name || "资讯"}
                  </span>
                  <h3 className="text-base font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2 mb-2">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed mb-4">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center gap-3 text-xs text-foreground-400">
                    <span>{article.author}</span>
                    <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                    <span>{article.date}</span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}